<template>
  <div>

    <div>
        
      <!-- <b-loading :active=!loaded></b-loading> -->

      <transition name="fade">
        <!-- 
        <div class="workpost"
          v-show="loaded"
        > -->

        <div class="workpost">
          <section class="section primary-section">
          <div class="title workpost-title">
            {{ workpost.title }}
          </div>

          <div class="workpost-year">
            {{ workpost.year }}
          </div>

          <post-media 
            :postmedia="primaryMedia"
            class="primary-media"
          ></post-media>

          <vue-simple-markdown class="workpost-desc" :source="workpost.description"></vue-simple-markdown>
          </section>

          <!-- now loop through media -->
          <div class="columns is-multiline is-vcentered">

            <div class="column is-half sec-media"
              v-scroll-reveal
              v-for="(workpostmedia, index) in secondaryMedia" :key="index" 
              v-bind:id="'workmedia-' + workpostmedia.id"
            >
              <post-media :postmedia="workpostmedia"></post-media>
            </div>

          </div>

          <!--
          <router-link
            class="title workpost-title"
            :to="{ name: 'work', params: { id:  nextWork }}"
          >
            Next {{ nextWork }}

          </router-link>
          -->

        </div>

      </transition>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "Work",
  data() {
    return {
      loaded: false,
      router_id: this.$route.params.id,
      vimeoOptions: {
        responsive: true,
      },
    };
  },
  watch: {
    '$route'(to) {
      // update id
      this.router_id = to.params.id
      this.$store.dispatch('messages/getMessage', this.router_id)
    },
  },
  computed: {
    nextWork() {
      return this.workpost.id - 1
    },
    primaryMedia() {
      let filtered = this.workpost.postmedia_set.filter(work => {
        return work.primary === true
      })
      return filtered[0]
    },
    secondaryMedia() {
      let filtered = this.workpost.postmedia_set.filter(work => {
        return work.primary === false
      })
      return filtered
    },
    ...mapState({
      workpost: state => state.messages.works,
    })
  },
  methods: {
    onLoaded() {
      // console.log('loaded', this.workpost.title)
      this.loaded = true;
    },
  },
  created() {
    // console.log('this.router_id', this.router_id)
    this.$store.dispatch('messages/getMessage', this.router_id)
  },
}
</script>

<style lang="scss" scoped>

  @import '~bulma/sass/utilities/_all';

  .workpost {
    padding: 0em 1em 5em 1em;
    max-width: 100%;
    text-align: center;
  }
  .primary-section {
    min-height: 90vh;
    padding:0;
    margin:0;
  }
  .primary-media {
    margin: 1rem auto;
    max-height: 75%;
    max-width: 90%;
  }
  .workpost-title {
    margin-bottom: 0rem;
  }
  .workpost-year {
    font-style: italic;
  }
  .workpost-desc {
    padding: 1em 0;
    width: 50vw;
    margin-left: auto;
    margin-right: auto;
  }
  .fade-enter-active {
    transition: all 1s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to {
    transform: translateY(10px);
    opacity: 0;
  }
  .embed-container {
    max-height: 75vh;
    max-width: 95vw;
  }
  .columns {
    margin: 1rem 0 ;
  }

  @include mobile {
    .workpost {
      height: auto; // without a set height, inital scrolling doesnt end in the correct pos
      padding: .5em 0em 1em 0;
    }
    .workpost-title {
      margin: 0.5em;
      font-size: 1.5rem;
    }
    .workpost-desc {
      margin: 0.5em;
      padding: 0 .5em;
      width: 100vw;
      margin-left: auto;
      margin-right: auto;
    }
    .primary-media {
      margin: 1rem auto;
      max-height: 100%;
      max-width: 100%;
    }
    .primary-section {
      min-height: 0;
      padding:0;
      margin:0;
    }
    // bug fix! otherwise columns are bigger than full width
    .columns {
      margin-left: 0;
      margin-right: 0;
    }
    .column {
      padding: 0rem 1rem;
    }
  }

</style>
